import { styled } from "@mui/styles"
// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import React from "react"

import { Icon, List } from "@cirrus/ui-kit"

const StepsListRoot = styled(List.Root)({
  backgroundColor: "#6b546a",
  borderRadius: 4,
  color: "#ffffff",
  fontSize: "1.4rem",
  maxWidth: 376,
  padding: "1rem",
  width: "100%",

  "&[class*=MuiList-root]": {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    "& .MuiListItem-root": {
      padding: 0,
      height: "44px"
    }
  }
})

const DoneStep = styled(List.Item)({
  "& > .MuiListItemIcon-root": {
    opacity: ".4",
    minWidth: "40px"
  },
  "& > .MuiListItemText-root": { textDecoration: "line-through" },
})

const ListHeader = styled("div")({
  fontSize: "17px",
  lineHeight: "24px",
  fontWeight: "700",
  marginBottom: "8px"
})

const ListDescription = styled("div")({
  fontSize: "14px",
  lineHeight: "20px",
  marginBottom: "8px"
})

const CheckMark = <Icon color="#ffffff" name="check" />

const LearnMoreLink = styled("a")({
  background: "#fff",
  border: "2px solid rgba(86, 70, 85, 0.5)",
  borderRadius: "4px",
  color: "rgba(85, 72, 84, 1) ",
  display: "block",
  height: "36px",
  lineHeight: "33px",
  fontWeight: "bold",
  textAlign: "center",
  marginTop: "16px"
})


interface IArgs {
  items: {
    checked: boolean,
    content: string,
  }[],
  title?: string | false,
  description?: string | false,
  learnMore?: string | false
}

export const CheckedList = ({ items, title = false, description = false, learnMore = false }: IArgs) => {
  return (
    <StepsListRoot>
      {(title || description) && (
        <>
          <ListHeader>{title}</ListHeader>
          <ListDescription>{description}</ListDescription>
        </>
      )}
      {items.map((item) => {
        return item.checked ? (
          <DoneStep
            adornment={CheckMark}
            content={item.content}
            ContentProps={{ disableTypography: true }}
          />
        ) : (
          <List.Item
            adornment={CheckMark}
            content={item.content}
            ContentProps={{ disableTypography: true }}
          />
        )
      })}
      {learnMore && (
        <LearnMoreLink target="_blank" href={learnMore}>
          {i18n("General:LearnMore")}
        </LearnMoreLink>
      )}
    </StepsListRoot>
  )
}
